import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { Timeline } from "@/components/Timeline";
import { BackButton } from "@/components/ui/BackButton";
import { sortFillOutData } from "@/features/Timeline/helpers";
import { PendingForRespondent } from "@/features/Timeline/PendingResponses/PendingForRespondent";
import { PendingPageQuery } from "@/features/Timeline/PendingResponses/PendingPageQuery";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute("/$organizationKey/$dossierId/pending")({
  component: Page,
});

function Page() {
  const { dossierId } = useSessionContext();
  const { data } = useSuspenseQuery(PendingPageQuery, {
    variables: { dossierId },
  });
  const { t } = useTranslation("Timeline");

  const fillOutData = data.dossier.respondents.flatMap((respondent) =>
    respondent.fillOutTask.fillOutMoments.map((fillOutMoment) => ({
      respondent,
      fillOutMoment,
    })),
  );
  const sortedFillOutData = sortFillOutData(fillOutData);

  return (
    <>
      <PageTitle title="pending" />
      <Section variant="header">
        <SectionHeader
          header={t("pending.managePage.header")}
          buttons={<BackButton href="/$organizationKey/$dossierId" />}
        />
        <p>{t("pending.managePage.description")}</p>
      </Section>

      <Section>
        <Timeline>
          {sortedFillOutData.map(({ respondent, fillOutMoment }, idx) => (
            <PendingForRespondent
              key={fillOutMoment.id}
              respondent={respondent}
              fillOutMoment={fillOutMoment}
              last={idx === sortedFillOutData.length - 1}
            />
          ))}
        </Timeline>
      </Section>
    </>
  );
}
